(function ($) {
  window.site = site || {};
  site.offers = site.offers || {};
  site.offers.welcome15 = site.offers.welcome15 || {};

  Drupal.behaviors.special_offer_row_mobile = {
    attach: function (context) {
      $('.js-special-offer-button-mobile-popup', context)
        .closest('.js-special-offer-row-mobile')
        .click(function (e) {
          e.preventDefault();
          $(document).trigger('loyalty.show_signup_form', [{ joinNowButtonClicked: true }]);
        });

      $('.js-special-offer-row-mobile', context).each(function () {
        var $specialOfferButton = $(this).find('.js-special-offer-button');
        var $aTag = $(this).find('a');

        $(this)
          .find('.js-special-offer-image')
          .click(function (e) {
            var $cta = $('#' + $(this).data('ctaId'));

            e.preventDefault();

            if ($specialOfferButton.length) {
              $specialOfferButton[0].click();
            } else if ($aTag.length) {
              $aTag.first()[0].click();
            } else if ($cta.length) {
              $cta[0].click();
            }
          });
      });
    } // attach
  };
})(jQuery);
